function parseArray(val) {
  try {
    if (typeof val === 'string')
      return JSON.parse(val);
    return val;
  }
  catch (e) {
    return [];
  }
}
function filterOptions(value, options, showField) {
  return options.filter(el => {
    return el[showField]
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .includes(value);
  });
}
const nullOption = {
  value: '',
  text: '',
};
function findOption(value, optionsArray, showfield, valuefield) {
  let option = nullOption;
  if (optionsArray && value) {
    const matchOption = optionsArray.find(obj => obj[valuefield] === value);
    option = {
      value: matchOption && matchOption[valuefield] !== '' ? matchOption[valuefield] : '',
      text: matchOption ? matchOption[showfield] : '',
    };
    return option;
  }
  return option;
}
function findOptions(values, optionsArray, showfield, valuefield) {
  const options = [];
  if (optionsArray && values && Array.isArray(values)) {
    values.forEach(userOption => {
      const matchOption = optionsArray.find(obj => obj[valuefield] === userOption);
      if (matchOption && matchOption[valuefield] !== '' && matchOption[showfield]) {
        const option = {
          value: matchOption[valuefield],
          text: matchOption[showfield],
        };
        options.push(option);
      }
    });
  }
  return options;
}

export { filterOptions as a, findOptions as b, findOption as f, nullOption as n, parseArray as p };
